/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersTenantResponseDto } from '../../models/users-tenant-response-dto';

export interface TenantsControllerFindOne$Params {

/**
 * The ID of the tenant to retrieve.
 */
  id: string;
}

export function tenantsControllerFindOne(http: HttpClient, rootUrl: string, params: TenantsControllerFindOne$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersTenantResponseDto>;
    })
  );
}

tenantsControllerFindOne.PATH = '/o2-users/tenants/{id}';
